import { render, staticRenderFns } from "./QuestionsWithAnswers.vue?vue&type=template&id=524831dc&scoped=true&"
import script from "./QuestionsWithAnswers.vue?vue&type=script&lang=js&"
export * from "./QuestionsWithAnswers.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsWithAnswers.vue?vue&type=style&index=0&id=524831dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524831dc",
  null
  
)

export default component.exports